import type { ValueOf } from 'type-fest';

export type OptOutReason = ValueOf<typeof OPT_OUT_REASONS>;

// TODO(ZRM-17899): replace with the generated ApplicationsOptOutReason enum once the BE endpoint ships.
export const OPT_OUT_REASONS = {
  USES_OTHER_SCREENING_TOOL: 'USES_OTHER_SCREENING_TOOL',
  USES_OWN_APPLICATION: 'USES_OWN_APPLICATION',
  FEE_TOO_HIGH: 'FEE_TOO_HIGH',
  NO_SCREENING_REPORT_NEEDED: 'NO_SCREENING_REPORT_NEEDED',
  UNCLEAR_VALUE: 'UNCLEAR_VALUE',
  WANTS_CONTROL_OVER_APPLICANTS: 'WANTS_CONTROL_OVER_APPLICANTS',
  NOT_ALLOWED_BY_OWNER: 'NOT_ALLOWED_BY_OWNER',
} as const;

export const OPT_OUT_REASON_OPTIONS = [
  {
    reason: OPT_OUT_REASONS.USES_OTHER_SCREENING_TOOL,
    label: 'I already screen applicants through another tool',
  },
  {
    reason: OPT_OUT_REASONS.USES_OWN_APPLICATION,
    label: 'I use my own or a paper application',
  },
  {
    reason: OPT_OUT_REASONS.FEE_TOO_HIGH,
    label: 'The application fee is too high for my renters',
  },
  {
    reason: OPT_OUT_REASONS.NO_SCREENING_REPORT_NEEDED,
    label: 'I don’t need a credit or background report for this unit',
  },
  {
    reason: OPT_OUT_REASONS.UNCLEAR_VALUE,
    label: 'I’m not clear on what I get from Zillow applications',
  },
  {
    reason: OPT_OUT_REASONS.WANTS_CONTROL_OVER_APPLICANTS,
    label: 'I want to control who applies and when',
  },
  {
    reason: OPT_OUT_REASONS.NOT_ALLOWED_BY_OWNER,
    label: 'My owner or management company doesn’t allow it',
  },
] as const;
